import { cond, flow, get, isEqual, stubTrue as otherwise } from 'lodash/fp';

import {
  Card as PaymentCardIcon,
  PaymentCardVisa as PaymentCardVisaIcon,
  PaymentMasterCard as PaymentMasterCardIcon,
} from '../../../icons';

const getType = get('type');
const equalsVisa = isEqual('visa');
const equalsMasterCard = isEqual('mastercard');

export const isVisa = flow(getType, equalsVisa);
export const isMasterCard = flow(getType, equalsMasterCard);

export const getCardIcon = cond([
  [isMasterCard, PaymentMasterCardIcon],
  [isVisa, PaymentCardVisaIcon],
  [otherwise, PaymentCardIcon],
]);

export const getIsHTTPS = (): boolean => window.location.protocol === 'https:';
